import { ApiData } from 'states/types'
import { Amenity } from 'types/amenity-booking'

const Types = {
  SET: '@@amenity/SET',
  ADD: '@@amenity/ADD',
  UPDATE: '@@amenity/UPDATE',
  LOADING: '@@amenity/LOADING'
}

export type Payload = ApiData<Amenity>

export { Types }
